import * as actionImport from './workflow.actions';
import * as selectorsImport from './workflow.selectors';
import { reducerWorkflowActions } from './workflow.reducer';
export { default } from './workflow.reducer';

export const workflowActions = { ...actionImport, ...reducerWorkflowActions };
export const workflowSelectors = selectorsImport;
